import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import DOMPurify from "dompurify";
import { ArrowLeft, ArrowRight } from "lucide-react";
import client from "../lib/api";
import SEO from "../components/SEO";
import LeadMagnetForm from "../components/LeadMagnetForm";
import { Reveal } from "../components/Reveal";

export default function Articolo() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [related, setRelated] = useState([]);

  useEffect(() => {
    setArticle(null);
    client.get(`/articles/${slug}`).then((r) => {
      setArticle(r.data);
      client.get("/articles").then((all) => {
        setRelated(all.data.filter((x) => x.slug !== slug).slice(0, 2));
      });
    }).catch(() => setArticle(false));
  }, [slug]);

  if (article === null) return <div className="min-h-screen bg-nero" />;
  if (article === false) return (
    <div className="min-h-screen bg-nero flex items-center justify-center">
      <p className="text-panna/60">Storia non trovata. <Link to="/storie" className="text-oro underline">Torna alle storie</Link></p>
    </div>
  );

  return (
    <div data-testid="articolo-page">
      <SEO title={article.title} path={`/storie/${article.slug}`} description={article.excerpt} />
      <article className="bg-panna pt-40 pb-24">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <Link to="/storie" className="inline-flex items-center gap-2 text-nero/50 hover:text-bordeaux text-sm mb-10 transition-colors">
            <ArrowLeft size={15} /> Tutte le storie
          </Link>
          <Reveal>
            <span className="text-[0.65rem] uppercase tracking-[0.25em] text-oliva">{article.category}</span>
            <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-nero mt-4 leading-tight">{article.title}</h1>
            <p className="mt-5 text-sm text-nero/50">
              {new Date(article.published_at).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}
              {" · "}{article.reading_time} min di lettura · di Stefano Cremonese
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="article-body mt-12" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(article.content) }} />
          </Reveal>
          <Reveal delay={0.1}>
            <div className="my-14 rounded-2xl bg-bordeaux p-8 sm:p-10 grain relative" data-testid="article-lead-box">
              <h2 className="font-serif text-2xl font-bold text-panna">Scarica la guida gratuita</h2>
              <p className="mt-3 text-panna/75 text-sm leading-relaxed">
                "7 Errori Comuni che (quasi) tutti commettono quando bevono vino" — 12 pagine, gratis.
              </p>
              <div className="mt-6">
                <LeadMagnetForm dark source={`articolo-${slug}`} />
              </div>
            </div>
          </Reveal>
          {related.length > 0 && (
            <div className="mt-16">
              <h2 className="font-serif text-2xl font-bold text-bordeaux mb-8">Storie correlate</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                {related.map((r) => (
                  <Link key={r.id} to={`/storie/${r.slug}`} data-testid={`related-${r.slug}`}
                        className="group rounded-2xl border border-nero/10 bg-panna-dark/40 p-6 block">
                    <span className="text-[0.65rem] uppercase tracking-[0.2em] text-oliva">{r.category}</span>
                    <h3 className="font-serif text-lg font-semibold text-nero mt-2 leading-snug group-hover:text-bordeaux transition-colors">{r.title}</h3>
                    <span className="mt-3 inline-flex items-center gap-1.5 text-sm text-bordeaux">Leggi <ArrowRight size={14} /></span>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </article>
    </div>
  );
}
